import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

export interface DialogFields {
  openedPage: ComponentType<any>;
  data: object;
  className?: string;
  callBackFunction?: ($event, ...$args) => void;
}

@Injectable({
  providedIn: 'root'
})
export class ViasDialogService {
  private config: MatDialogConfig;
  private openedPage: ComponentType<any>;

  constructor(
    private dialog: MatDialog
  ) {
    this.config = {
      disableClose: false,
      hasBackdrop: true,
    };
  }
  setConfig(conf: {} = {}): void {
    for (const x in conf) {
      this.config[x] = conf[x];
    }
  }
  setComponent(openedPage: ComponentType<any>): void {
    this.openedPage = openedPage;
  }
  open(): MatDialogRef<any, any> {
    return this.dialog.open(this.openedPage, this.config);
  }
}
